export default __webpack_public_path__ + "static/delegator-27b363116eb89cd21be25ec10933384a.png";